import DeleteIcon from "@mui/icons-material/Delete"
import { Button, Container, Grid, Typography } from "@mui/material"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import AlertDialog from "../components/common/AlertDialog"
import PageSection from "../components/common/page/PageSection"
import ChangePassword from "../components/settings/ChangePassword"
import MyProfile from "../components/settings/MyProfile"
import UserLicense from "../components/settings/UserLicense"
import { useAppDispatch } from "../hooks/useRedux"
import { useSession } from "../hooks/useSession"
import { deleteProfileAsync } from "../store/slices/user.slice"
import { UserRole } from "../constants/roles.enum"

export default function Profile() {
    const [openDeleteAlert, setOpenDeleteAlert] = useState<boolean>(false)
    const { t } = useTranslation()
    const dispatch = useAppDispatch()
    const { hasRole } = useSession()

    const navigate = useNavigate()
    const onDelete = async () => {
        setOpenDeleteAlert(false)
        await dispatch(deleteProfileAsync())
        navigate("/signup")
    }
    const handleNavigateToSuperAdmin = () => {
        navigate("/admin/users")
    }
    return (
        <Container component="main" maxWidth="lg">
            <Grid container my={4} justifyContent="space-between" alignItems="center">
                <Grid item>
                    <Typography variant="h2">{t("user:settingsProfile")}</Typography>
                </Grid>
                <Grid item>
                    {hasRole(UserRole.Admin) && (
                        <Typography variant="h5">
                            <Button variant="text" onClick={handleNavigateToSuperAdmin}>
                                {t("user:button.usersAdmin")}
                            </Button>
                        </Typography>
                    )}
                </Grid>
            </Grid>
            <Grid item xs={12} sx={{ borderBottom: 1 }}></Grid>

            <PageSection
                heading={t("user:userProfileHeading")}
                description={t("user:userProfileDescription")}
                section={<MyProfile />}
            />

            <PageSection
                heading={t("user:licenseDetailHeading")}
                description={t("user:licenseDetailDescription")}
                descriptionAction={
                    <Button
                        variant="text"
                        component="a"
                        href="https://tweenly.io/#pricing"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {t("user:button.showLicenses")}
                    </Button>
                }
                section={<UserLicense />}
            />

            <PageSection
                heading={t("user:changePasswordHeading")}
                description={t("user:changePasswordDescription")}
                section={<ChangePassword />}
            />

            <PageSection
                heading={t("user:deleteProfileHeading")}
                description={t("user:deleteProfileDescription")}
                section={
                    <Button
                        variant="text"
                        color="error"
                        startIcon={<DeleteIcon />}
                        onClick={() => setOpenDeleteAlert(true)}
                    >
                        <Typography variant="body2">{t("user:settingsDeleteProfile")}</Typography>
                    </Button>
                }
            />
            {openDeleteAlert && (
                <AlertDialog
                    open={openDeleteAlert}
                    title={t("user:settingsDeleteProfileTitle")}
                    content={t("user:settingsDeleteProfileContent")}
                    onDisagree={() => setOpenDeleteAlert(false)}
                    onAgree={onDelete}
                    txtDisagree={t("disagree")}
                    txtAgree={t("delete")}
                    colorAgree="error"
                />
            )}
        </Container>
    )
}
